import { useFormikContext } from "formik"
import React, { useRef } from "react"
import { findField, findFieldset } from "@app/utils/form"

const FIELD_NAME_CATEGORY = "physischegefaehrdungsanalyse_kategorie_kategorie"

export const useDangerCategoryObserver = (currentFieldsets, { resetValues }) => {
	const { values, setFieldValue, setValues } = useFormikContext()
	const categoryValueRef = useRef(values.physischegefaehrdungsanalyse_kategorie_kategorie)

	// patch field "physischegefaehrdungsanalyse_kategorie_kategorie" to element type "radioTabs"
	const categoryField = findField(currentFieldsets, FIELD_NAME_CATEGORY)
	let res = React.useMemo(() => {
		if (categoryField) {
			categoryField.elementType = "radioTabs"

			return {
				fieldsets: currentFieldsets
			}
		}
		return {
			fieldsets: currentFieldsets
		}
	}, [categoryField])

	// patch fieldset including field "physischegefaehrdungsanalyse_kategorie_kategorie"
	const categoryFieldset = findFieldset(res.fieldsets, FIELD_NAME_CATEGORY)
	res = React.useMemo(() => {
		if (categoryField) {
			categoryFieldset.layout = {
				tabsContainer: true,
			}
		}
		return res
	}, [categoryFieldset])

	// set default value for field
	const categoryValue = values[FIELD_NAME_CATEGORY]
	res = React.useMemo(() => {
		if (categoryValue === "") {
			const defaultOption = categoryField.options?.find(({ selected }) => selected)
			setFieldValue(FIELD_NAME_CATEGORY, defaultOption.value)
		}
		return res
	}, [])

	// reset all values beyond the danger fields, when "physischegefaehrdungsanalyse_kategorie_kategorie" value changes
	res = React.useMemo(() => {
		if (categoryValueRef.current && categoryValueRef.current !== "" && categoryValue !== "" && categoryValueRef.current !== categoryValue) {
			delete resetValues[FIELD_NAME_CATEGORY]
			const updateValues = { ...values, ...resetValues }
			setValues(updateValues)
		}
		categoryValueRef.current = categoryValue
		return res
	}, [categoryValue])

	return res
}
